import type { FaireProductEntity } from "../../entity_types/product";

export const p_ysyjpdhhrm: FaireProductEntity = {
  token: "p_ysyjpdhhrm",
  type: "product",
  name: "Soft Dried Pineapple",
  brandName: "Nakihalani Farm",
  imageUrl:
    "https://cdn.faire.com/fastly/dc8be70a45ae430d9289767882bab69434ab336e2e1d0e98a2222eded0da7801.png",
  priceDollars: 4.5,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/5021a26ce084aaeb2fdc01898db7ab8d6cdc8f52b88a340ad9c2ebba4b153d03.jpeg",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
